
export const en_DICTIONARY: Object = {
	'EXAMPLES': {
		'EXAMPLE1': 'Example1'
	}
};